export const REQUEST = 'TOURNAMENTS/REQUEST';
export const RECEIVE = 'TOURNAMENTS/RECEIVE';